var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.77818C8.53553 9.77818 9.375 8.93697 9.375 7.89929C9.375 6.86161 8.53553 6.0204 7.5 6.0204C6.46447 6.0204 5.625 6.86161 5.625 7.89929C5.625 8.93697 6.46447 9.77818 7.5 9.77818Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5031 7.73958C13.9518 6.31052 12.9947 5.07467 11.7501 4.18476C10.5055 3.29486 9.0279 2.78992 7.50001 2.73234C5.97213 2.78992 4.49457 3.29486 3.24995 4.18476C2.00533 5.07467 1.04821 6.31052 0.496889 7.73958C0.459655 7.84279 0.459655 7.95579 0.496889 8.059C1.04821 9.48806 2.00533 10.7239 3.24995 11.6138C4.49457 12.5037 5.97213 13.0087 7.50001 13.0662C9.0279 13.0087 10.5055 12.5037 11.7501 11.6138C12.9947 10.7239 13.9518 9.48806 14.5031 8.059C14.5404 7.95579 14.5404 7.84279 14.5031 7.73958ZM7.50001 10.9525C6.8974 10.9525 6.30832 10.7734 5.80726 10.4379C5.30621 10.1024 4.91568 9.6256 4.68507 9.0677C4.45446 8.5098 4.39412 7.8959 4.51168 7.30364C4.62925 6.71138 4.91943 6.16735 5.34555 5.74035C5.77166 5.31336 6.31456 5.02257 6.9056 4.90476C7.49663 4.78695 8.10926 4.84742 8.666 5.0785C9.22275 5.30959 9.6986 5.70093 10.0334 6.20303C10.3682 6.70512 10.5469 7.29542 10.5469 7.89929C10.5456 8.70867 10.2242 9.48454 9.65311 10.0569C9.08198 10.6292 8.30771 10.9512 7.50001 10.9525Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.7195ef0eef66df9d87b8d0e314251db0.svg";
export { ForwardRef as ReactComponent };